'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var util = require('../../helper/util');


var PageControlEx = React.createClass({
  getInitialState: function () {
    return {
      selectedIndex: this.props.selectedIndex,
      columnCount: this.props.columnCount,
      shapeType: this.props.shapeType
    }
  },

  render: function () {
    var cssIcon = {
      width: this.props.size,
      height: this.props.size
    };

    if (this.props.borderVisible) {
      cssIcon.border = '1px solid ' + this.props.borderColor;
    }

    if (this.state.shapeType == 'stSquare') {
      cssIcon.border = '1px solid ' + this.props.color;
      cssIcon.backgroundColor = '#fff';
      cssIcon.borderRadius = '0';
    }

    var self = this;

    return (<div ref='asd' className="component component-PageControlEx"
                 style={{width: this.state.columnCount * cssIcon.width + this.state.columnCount * this.props.gap}}>
      <ul ref="list">
        {
          util.Util.map(this.state.columnCount, function (o, i) {
            if (self.state.shapeType == 'stRound') {
              return (
                <li style={cssIcon} className="stRound" key={i}></li>
              )
            } else if (self.state.shapeType == 'stHollowRect') {
              return (
                <li style={cssIcon} className="stHollowRect" key={i}></li>
              )
            } else if (self.state.shapeType == 'stSquare') {
              return (
                <li style={cssIcon} className="stSquare" key={i}></li>
              )
            }
          })
        }
      </ul>
    </div>);
  },

  componentDidMount: function () {
    var dom = ReactDOM.findDOMNode(this.refs.list);
    var i;
    var li;
    for (i = 0; i < dom.children.length; i++) {
      li = dom.children[i];
      $(li).off('click');
      $(li).on('click', {index: i}, this.onItemClick)
    }

    this.doSelect();
  },

  componentDidUpdate: function () {
    this.doSelect();
  },

  onItemClick: function (e) {
    var index = e.data.index;
    this.setState({selectedIndex: index});
  },

  doSelect: function () {
    var dom = ReactDOM.findDOMNode(this);
    var i;
    var li;
    var bg;
    dom = dom.children[0];

    for (i = 0; i < dom.children.length; i++) {
      li = dom.children[i];
      if (i === this.state.selectedIndex) {
        bg = this.props.selectedColor || '#41c7d6';
      } else {
        bg = this.props.color || '#dddddd';
      }
      $(li).css({
        backgroundColor: bg,
        borderColor: this.props.borderColor || bg
      });
    }
  }
});

module.exports = PageControlEx;



// WEBPACK FOOTER //
// ./src/views/Components/PageControlEx.jsx